import { render, staticRenderFns } from "./media-header.vue?vue&type=template&id=1ffa4908&scoped=true&"
import script from "./media-header.vue?vue&type=script&lang=js&"
export * from "./media-header.vue?vue&type=script&lang=js&"
import style0 from "./media-header.vue?vue&type=style&index=0&id=1ffa4908&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa4908",
  null
  
)

export default component.exports